import React from 'react';

export default function DeerEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="38.0,23.5 27.0,23.5 27.0,16.5 38.0,16.5" fill="#E1D2DB" />
      <polygon points="38.0,23.5 27.0,23.5 27.0,16.5 38.0,16.5" fill="#E1D2DB" />
      <polygon points="13.0,23.5 2.0,23.5 2.0,16.5 13.0,16.5" fill="#E1D2DB" />
      <polygon points="13.0,23.5 2.0,23.5 2.0,16.5 13.0,16.5" fill="#E1D2DB" />
      <polygon points="36.6,22.8 27.6,22.8 27.6,17.8 36.6,17.8" fill="#E1D2DB" />
      <polygon points="27.6,22.8 36.6,22.8 36.0,22.5 27.0,22.5" fill="#B894AA" opacity="0.95" />
      <polygon points="27.6,22.8 27.0,22.5 27.0,17.5 27.6,17.8" fill="#B894AA" opacity="0.95" />
      <polygon points="13.6,22.8 4.6,22.8 4.6,17.8 13.6,17.8" fill="#E1D2DB" />
      <polygon points="4.6,22.8 13.6,22.8 13.0,22.5 4.0,22.5" fill="#B894AA" opacity="0.95" />
      <polygon points="4.6,22.8 4.0,22.5 4.0,17.5 4.6,17.8" fill="#B894AA" opacity="0.95" />
    </svg>
  );
}
